import styled from 'styled-components';

export const StyledPopoverContent = styled.div`
  &&& {
    width: 312px;
    padding: 16px;

    :focus-visible {
      outline: none;
    }

    /* When rendering tabs using config object this stays empty and is caught with focus */
    .ant-tabs-content-holder {
      display: none;
    }

    .ant-form-item {
      margin-bottom: 0px;
    }
  }
`;
